module.exports = __webpack_public_path__ + "img/GR116.618b4906.png";